import { request } from 'ice';
import { INBOUNDSERVICE } from '@/const';

// 总单
const getAllOrderQty = (obj: Object) => {
  return request.post(`${INBOUNDSERVICE}/outboundBoard/countTotalOutboundOrderQty`, obj);
};

// 待出库
const getWaitOrderQty = (obj: Object) => {
  return request.post(`${INBOUNDSERVICE}/outboundBoard/countPendingOutboundOrderQty`, obj);
};

// 预估产能
const getPlanCapacity = (obj: object) => {
  return request.post(`${INBOUNDSERVICE}/outboundBoard/getOutboundExpectCapacity`, obj);
};

export { getAllOrderQty, getWaitOrderQty, getPlanCapacity };
